import React from 'react';

// Figma 디자인 화면(118:9281)에서 추출한 커스텀 아이콘 컴포넌트
// Officewave/Officeware 아이콘 세트 기반
// 생성일: 2026-03-31

export const IconHash = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M4.25 14L7.25 2M8.75 14L11.75 2M3.5 5.75H14M2 10.25H12.5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const IconMoreHorizontal = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M15.8333 9.99996L15.825 9.99996M9.99996 9.99996L9.99163 9.99996M4.16663 9.99996L4.15829 9.99996M15 9.99996C15 9.77895 15.0878 9.56698 15.244 9.4107C15.4003 9.25442 15.6123 9.16663 15.8333 9.16663C16.0543 9.16663 16.2663 9.25442 16.4225 9.4107C16.5788 9.56698 16.6666 9.77895 16.6666 9.99996C16.6666 10.221 16.5788 10.4329 16.4225 10.5892C16.2663 10.7455 16.0543 10.8333 15.8333 10.8333C15.6123 10.8333 15.4003 10.7455 15.244 10.5892C15.0878 10.4329 15 10.221 15 9.99996ZM9.16663 9.99996C9.16663 9.77895 9.25442 9.56698 9.4107 9.4107C9.56698 9.25442 9.77895 9.16663 9.99996 9.16663C10.221 9.16663 10.4329 9.25442 10.5892 9.4107C10.7455 9.56698 10.8333 9.77895 10.8333 9.99996C10.8333 10.221 10.7455 10.4329 10.5892 10.5892C10.4329 10.7455 10.221 10.8333 9.99996 10.8333C9.77895 10.8333 9.56698 10.7455 9.4107 10.5892C9.25442 10.4329 9.16663 10.221 9.16663 9.99996ZM3.33329 9.99996C3.33329 9.77894 3.42109 9.56698 3.57737 9.4107C3.73365 9.25442 3.94561 9.16663 4.16663 9.16663C4.38764 9.16663 4.5996 9.25442 4.75588 9.4107C4.91216 9.56698 4.99996 9.77895 4.99996 9.99996C4.99996 10.221 4.91216 10.4329 4.75588 10.5892C4.5996 10.7455 4.38764 10.8333 4.16663 10.8333C3.94561 10.8333 3.73365 10.7455 3.57737 10.5892C3.42109 10.4329 3.33329 10.221 3.33329 9.99996Z" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const IconMoreVertical = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 4 16"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M2 1.83333V1.84167M2 7.66667V7.675M2 13.5V13.5083M2 2.66667C1.77899 2.66667 1.56702 2.57887 1.41074 2.42259C1.25446 2.26631 1.16667 2.05435 1.16667 1.83333C1.16667 1.61232 1.25446 1.40036 1.41074 1.24408C1.56702 1.0878 1.77899 1 2 1C2.22101 1 2.43298 1.0878 2.58926 1.24408C2.74554 1.40036 2.83333 1.61232 2.83333 1.83333C2.83333 2.05435 2.74554 2.26631 2.58926 2.42259C2.43298 2.57887 2.22101 2.66667 2 2.66667ZM2 8.5C1.77899 8.5 1.56702 8.4122 1.41074 8.25592C1.25446 8.09964 1.16667 7.88768 1.16667 7.66667C1.16667 7.44565 1.25446 7.23369 1.41074 7.07741C1.56702 6.92113 1.77899 6.83333 2 6.83333C2.22101 6.83333 2.43298 6.92113 2.58926 7.07741C2.74554 7.23369 2.83333 7.44565 2.83333 7.66667C2.83333 7.88768 2.74554 8.09964 2.58926 8.25592C2.43298 8.4122 2.22101 8.5 2 8.5ZM2 14.3333C1.77899 14.3333 1.56702 14.2455 1.41074 14.0893C1.25446 13.933 1.16667 13.721 1.16667 13.5C1.16667 13.279 1.25446 13.067 1.41074 12.9107C1.56702 12.7545 1.77899 12.6667 2 12.6667C2.22101 12.6667 2.43298 12.7545 2.58926 12.9107C2.74554 13.067 2.83333 13.279 2.83333 13.5C2.83333 13.721 2.74554 13.933 2.58926 14.0893C2.43298 14.2455 2.22101 14.3333 2 14.3333Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const IconSmilePlus = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 18 18"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M15.7499 9C15.7499 12.7279 12.7279 15.75 8.99994 15.75C5.27202 15.75 2.24994 12.7279 2.24994 9C2.24994 5.27208 5.27202 2.25 8.99994 2.25M11.1213 11.1213C9.94969 12.2929 8.05019 12.2929 6.87862 11.1213M6.74994 7.5H6.75744M11.2499 7.5H11.2574M13.8749 2.25V4.125M13.8749 4.125V6M13.8749 4.125H15.7499M13.8749 4.125L11.9999 4.125" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const IconSparkles = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="1.5 1.5 17 17"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path fillRule="evenodd" clipRule="evenodd" d="M8.33333 5.83333C7.8101 5.83333 7.34558 6.16815 7.18012 6.66453L6.72548 8.02844C6.40594 8.98705 5.65372 9.73927 4.69511 10.0588L3.33119 10.5135C2.83481 10.6789 2.5 11.1434 2.5 11.6667C2.5 12.1899 2.83481 12.6544 3.33119 12.8199L4.69511 13.2745C5.65372 13.5941 6.40594 14.3463 6.72548 15.3049L7.18012 16.6688C7.34558 17.1652 7.8101 17.5 8.33333 17.5C8.85656 17.5 9.32109 17.1652 9.48655 16.6688L9.94119 15.3049C10.2607 14.3463 11.0129 13.5941 11.9716 13.2745L13.3355 12.8199C13.8319 12.6544 14.1667 12.1899 14.1667 11.6667C14.1667 11.1434 13.8319 10.6789 13.3355 10.5135L11.9716 10.0588C11.0129 9.73927 10.2607 8.98705 9.94119 8.02845L9.48655 6.66453C9.32109 6.16815 8.85656 5.83333 8.33333 5.83333Z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
    <path fillRule="evenodd" clipRule="evenodd" d="M14.5833 2.5C14.3217 2.5 14.0895 2.66741 14.0067 2.9156L13.7794 3.59756C13.6196 4.07686 13.2435 4.45297 12.7642 4.61274L12.0823 4.84006C11.8341 4.92279 11.6667 5.15505 11.6667 5.41667C11.6667 5.67828 11.8341 5.91055 12.0823 5.99328L12.7642 6.2206C13.2435 6.38036 13.6196 6.75647 13.7794 7.23578L14.0067 7.91774C14.0895 8.16593 14.3217 8.33333 14.5833 8.33333C14.8449 8.33333 15.0772 8.16593 15.1599 7.91774L15.3873 7.23578C15.547 6.75647 15.9231 6.38036 16.4024 6.22059L17.0844 5.99328C17.3326 5.91055 17.5 5.67828 17.5 5.41667C17.5 5.15505 17.3326 4.92279 17.0844 4.84006L16.4024 4.61274C15.9231 4.45297 15.547 4.07686 15.3873 3.59756L15.1599 2.9156C15.0772 2.66741 14.8449 2.5 14.5833 2.5Z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
  </svg>
);

export const IconChevronDown = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 14 14"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M11.0834 5.25L7.00002 9.33333L2.91669 5.25" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

// Figma: plus (87:8837) — 24x24 캔버스, inset 20.83% (5px) → 14x14 영역
// 광학 보정: 가는 십자 선은 원/면보다 시각적으로 커 보이므로 여백을 줌
export const IconPlus = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <g transform="translate(3, 3) scale(1.125)">
      <path d="M8 1V15M1 8H15" stroke="currentColor" strokeWidth="1.778" strokeLinecap="round" strokeLinejoin="round" />
    </g>
  </svg>
);

export const IconUserPlus = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M9.11458 11.6667C9.11944 11.6667 9.1243 11.6667 9.12916 11.6667M9.12916 11.6667C10.3108 11.668 11.5619 11.7314 12.3235 11.857L12.4966 11.8855C14.4189 12.2025 15.8333 13.9153 15.8333 15.9262C15.8333 16.7954 15.1513 17.5 14.3099 17.5H4.02344C3.18207 17.5 2.5 16.7954 2.5 15.9262C2.5 13.9153 3.91444 12.2025 5.8367 11.8855L6.00985 11.857C6.77141 11.7314 7.94811 11.668 9.12916 11.6667ZM9.12916 11.6667C9.13402 11.6667 9.13888 11.6667 9.14374 11.6667M17.5 8.83333H15.8333M15.8333 8.83333H14.1667M15.8333 8.83333V10.5M15.8333 8.83333V7.16667M12.3335 5.66667C12.3335 7.41557 10.9157 8.83333 9.16683 8.83333C7.41793 8.83333 6.00016 7.41557 6.00016 5.66667C6.00016 3.91777 7.41793 2.5 9.16683 2.5C10.9157 2.5 12.3335 3.91777 12.3335 5.66667Z" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const IconLink = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 18 18"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M10.3713 7.62868C9.19975 6.45711 7.30025 6.45711 6.12868 7.62868L3.12868 10.6287C1.95711 11.8003 1.95711 13.6997 3.12868 14.8713C4.30025 16.0429 6.19975 16.0429 7.37132 14.8713L8.19749 14.0451M7.62868 10.3713C8.80025 11.5429 10.6997 11.5429 11.8713 10.3713L14.8713 7.37132C16.0429 6.19975 16.0429 4.30025 14.8713 3.12868C13.6997 1.95711 11.8003 1.95711 10.6287 3.12868L9.80397 3.95339" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const IconOutArrowRight = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 17 14"
    fill="none"
    {...props}
  >
    <path
      d="M11.2026 1.86747L15.862 6.78794C15.951 6.89569 16 7.03375 16 7.17663C16 7.31951 15.951 7.45757 15.862 7.56532L11.2026 12.477C11.0955 12.5889 10.9511 12.6523 10.8003 12.6536C10.7286 12.671 10.6541 12.671 10.5824 12.6536C10.4767 12.6102 10.3862 12.5334 10.3232 12.4339C10.2602 12.3343 10.2279 12.2167 10.2305 12.0971V9.5176C8.42873 9.45576 2.39498 8.69607 1.01225 1.72615C0.985994 1.59385 1.0022 1.45609 1.05833 1.33455C1.11446 1.21302 1.20732 1.1146 1.32231 1.05477C1.43899 0.998322 1.57031 0.985044 1.69503 1.01711C1.81975 1.04918 1.93055 1.12472 2.00947 1.23146C3.03397 2.45258 4.30281 3.41878 5.72445 4.06038C7.14609 4.70199 8.68511 5.00298 10.2305 4.94167V2.29151C10.2291 2.17215 10.2619 2.05514 10.3247 1.95582C10.3875 1.8565 10.4774 1.7795 10.5824 1.73497C10.6866 1.68999 10.8012 1.67858 10.9115 1.70216C11.0219 1.72575 11.1232 1.78326 11.2026 1.86747Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// Figma: mood-smile (87:9858) — 24x24 캔버스, inset 12.5% (3px) → 18x18 영역
export const IconMoodSmile = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <g transform="translate(1, 1) scale(1.1)">
      <path d="M7 8H7.01M13 8H13.01M7.5 13C7.82588 13.3326 8.21485 13.5968 8.64413 13.7772C9.07341 13.9576 9.53436 14.0505 10 14.0505C10.4656 14.0505 10.9266 13.9576 11.3559 13.7772C11.7852 13.5968 12.1741 13.3326 12.5 13M1 10C1 11.1819 1.23279 12.3522 1.68508 13.4442C2.13738 14.5361 2.80031 15.5282 3.63604 16.364C4.47177 17.1997 5.46392 17.8626 6.55585 18.3149C7.64778 18.7672 8.8181 19 10 19C11.1819 19 12.3522 18.7672 13.4442 18.3149C14.5361 17.8626 15.5282 17.1997 16.364 16.364C17.1997 15.5282 17.8626 14.5361 18.3149 13.4442C18.7672 12.3522 19 11.1819 19 10C19 8.8181 18.7672 7.64778 18.3149 6.55585C17.8626 5.46392 17.1997 4.47177 16.364 3.63604C15.5282 2.80031 14.5361 2.13738 13.4442 1.68508C12.3522 1.23279 11.1819 1 10 1C8.8181 1 7.64778 1.23279 6.55585 1.68508C5.46392 2.13738 4.47177 2.80031 3.63604 3.63604C2.80031 4.47177 2.13738 5.46392 1.68508 6.55585C1.23279 7.64778 1 8.8181 1 10Z" stroke="currentColor" strokeWidth="1.818" strokeLinecap="round" strokeLinejoin="round" />
    </g>
  </svg>
);

// Figma: microphone (87:8950) — 24x24 캔버스, inset [top 2 right 5 bottom 3 left 5]
export const IconMicrophone = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <g transform="translate(3, 0.3) scale(1.125)">
      <path d="M1 9C1 10.8565 1.7375 12.637 3.05025 13.9497C4.36301 15.2625 6.14348 16 8 16M8 16C9.85652 16 11.637 15.2625 12.9497 13.9497C14.2625 12.637 15 10.8565 15 9M8 16V20M4 20H12M5 4C5 3.20435 5.31607 2.44129 5.87868 1.87868C6.44129 1.31607 7.20435 1 8 1C8.79565 1 9.55871 1.31607 10.1213 1.87868C10.6839 2.44129 11 3.20435 11 4V9C11 9.79565 10.6839 10.5587 10.1213 11.1213C9.55871 11.6839 8.79565 12 8 12C7.20435 12 6.44129 11.6839 5.87868 11.1213C5.31607 10.5587 5 9.79565 5 9V4Z" stroke="currentColor" strokeWidth="1.778" strokeLinecap="round" strokeLinejoin="round" />
    </g>
  </svg>
);

// Figma: send (87:5134) — 24x24 캔버스, inset 12.5% (3px) → 18x18 영역
export const IconSend = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <g transform="translate(1, 1) scale(1.1)">
      <path d="M9 11L13 7M12.8058 19C15.1249 19 20.2747 2.85717 18.7087 1.29125C17.1427 -0.274691 1 4.87509 1 7.19417C1 8.91076 8.87055 11.1294 8.87055 11.1294C8.87055 13.0971 11.0892 19 12.8058 19Z" stroke="currentColor" strokeWidth="1.818" strokeLinecap="round" strokeLinejoin="round" />
    </g>
  </svg>
);

// ── 파일관리 모달 아이콘 (Figma Node 127:18643, Officeware 세트) ──

export const IconFileFolderPlus = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M8 12H3.33333C2.97971 12 2.64057 11.8595 2.39052 11.6095C2.14048 11.3594 2 11.0203 2 10.6667V3.33333C2 2.97971 2.14048 2.64057 2.39052 2.39052C2.64057 2.14048 2.97971 2 3.33333 2H6L8 4H12.6667C13.0203 4 13.3594 4.14048 13.6095 4.39052C13.8595 4.64057 14 4.97971 14 5.33333V7.66667M10.6667 12H14.6667M12.6667 10V14" />
  </svg>
);

export const IconFileUpload = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M2.66667 11.3333V12.6667C2.66667 13.0203 2.80714 13.3594 3.05719 13.6095C3.30724 13.8595 3.64638 14 4 14H12C12.3536 14 12.6928 13.8595 12.9428 13.6095C13.1929 13.3594 13.3333 13.0203 13.3333 12.6667V11.3333M4.66667 6L8 2.66667M8 2.66667L11.3333 6M8 2.66667V10.6667" />
  </svg>
);

export const IconFileTrash = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M2.66667 5.33333H13.3333M6.66667 8V12M9.33333 8V12M3.33333 5.33333L4 13.3333C4 13.687 4.14048 14.0261 4.39052 14.2761C4.64057 14.5262 4.97971 14.6667 5.33333 14.6667H10.6667C11.0203 14.6667 11.3594 14.5262 11.6095 14.2761C11.8595 14.0261 12 13.687 12 13.3333L12.6667 5.33333M6 5.33333V3.33333C6 3.15652 6.07024 2.98695 6.19526 2.86193C6.32029 2.73691 6.48986 2.66667 6.66667 2.66667H9.33333C9.51014 2.66667 9.67971 2.73691 9.80474 2.86193C9.92976 2.98695 10 3.15652 10 3.33333V5.33333" />
  </svg>
);

export const IconFileFolderMove = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M8.66667 12H3.33333C2.97971 12 2.64057 11.8595 2.39052 11.6095C2.14048 11.3594 2 11.0203 2 10.6667V3.33333C2 2.97971 2.14048 2.64057 2.39052 2.39052C2.64057 2.14048 2.97971 2 3.33333 2H6L8 4H12.6667C13.0203 4 13.3594 4.14048 13.6095 4.39052C13.8595 4.64057 14 4.97971 14 5.33333V8M10.6667 14L14 10.6667M14 10.6667V13.6667M14 10.6667H11" />
  </svg>
);

export const IconFileLink = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M6 10L10 6M7.33333 4L7.64217 3.64287C8.26737 3.01776 9.11529 2.6666 9.9994 2.66667C10.8835 2.66673 11.7314 3.018 12.3565 3.64321C12.9816 4.26841 13.3328 5.11633 13.3327 6.00044C13.3326 6.88455 12.9813 7.73243 12.3561 8.35754L12 8.66687M8.66676 12L8.4021 12.3561C7.7696 12.9817 6.91596 13.3324 6.02643 13.3324C5.13691 13.3324 4.28327 12.9817 3.65076 12.3561C3.339 12.0479 3.09149 11.6808 2.92257 11.2763C2.75365 10.8717 2.66667 10.4376 2.66667 9.99917C2.66667 9.56073 2.75365 9.12666 2.92257 8.72207C3.09149 8.31749 3.339 7.95042 3.65076 7.64217L4.0001 7.3335" />
  </svg>
);

export const IconFileFilter = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M1 3C1 1.89543 1.89543 1 3 1H17C18.1046 1 19 1.89543 19 3V4.67719C19 5.26273 18.7434 5.81887 18.2979 6.19886L12.5511 11.1006C12.3283 11.2906 12.2 11.5686 12.2 11.8614V14.2229C12.2 14.7975 11.9528 15.3444 11.5215 15.7241L8.13215 18.7076C8.00296 18.8213 7.8 18.7296 7.8 18.5575V11.8614C7.8 11.5686 7.6717 11.2906 7.44895 11.1006L1.70211 6.19886C1.2566 5.81887 1 5.26273 1 4.67719V3Z" />
  </svg>
);

// ── 파일관리 정렬/뷰모드 아이콘 (Figma Node 127:18663) ──

export const IconSortArrowDown = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M8 3V12.3333M8 12.3333L12 8.33333M8 12.3333L4 8.33333" />
  </svg>
);

export const IconSortChevronDown = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 14 14"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M3.5 5.25L7 8.75L10.5 5.25" />
  </svg>
);

export const IconViewList = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M4 4H20M4 8.66667H20M4 13.3333H20M4 18H20" />
  </svg>
);

export const IconViewGrid = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="-3 -3 26 26"
    fill="currentColor"
    {...props}
  >
    <path fillRule="evenodd" clipRule="evenodd" d="M1.02206 1.02206C1.86565 0.178474 3.11797 0 4.5 0C5.88026 0 7.14776 0.177265 7.99436 1.0646C8.82514 1.93537 9 3.23401 9 4.70588C9 6.00069 8.81654 7.20585 7.9603 8.02089C7.1207 8.82008 5.88439 9 4.5 9C3.11797 9 1.86565 8.82153 1.02206 7.97794C0.178474 7.13435 0 5.88203 0 4.5C0 3.11797 0.178474 1.86565 1.02206 1.02206ZM12.0221 1.02206C12.8656 0.178474 14.118 0 15.5 0C16.8803 0 18.1478 0.177265 18.9944 1.0646C19.8251 1.93537 20 3.23401 20 4.70588C20 6.00069 19.8165 7.20585 18.9603 8.02089C18.1207 8.82008 16.8844 9 15.5 9C14.118 9 12.8656 8.82153 12.0221 7.97794C11.1785 7.13435 11 5.88203 11 4.5C11 3.11797 11.1785 1.86565 12.0221 1.02206ZM1.02206 12.0221C1.86565 11.1785 3.11797 11 4.5 11C5.88026 11 7.14776 11.1773 7.99436 12.0646C8.82514 12.9354 9 14.234 9 15.7059C9 17.0007 8.81654 18.2059 7.9603 19.0209C7.1207 19.8201 5.88439 20 4.5 20C3.11797 20 1.86565 19.8215 1.02206 18.9779C0.178474 18.1344 0 16.882 0 15.5C0 14.118 0.178474 12.8656 1.02206 12.0221ZM12.0221 12.0221C12.8656 11.1785 14.118 11 15.5 11C16.8803 11 18.1478 11.1773 18.9944 12.0646C19.8251 12.9354 20 14.234 20 15.7059C20 17.0007 19.8165 18.2059 18.9603 19.0209C18.1207 19.8201 16.8844 20 15.5 20C14.118 20 12.8656 19.8215 12.0221 18.9779C11.1785 18.1344 11 16.882 11 15.5C11 14.118 11.1785 12.8656 12.0221 12.0221Z" />
  </svg>
);
